import {
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  Warning as WarningIcon,
  Archive as ArchiveIcon
} from '@mui/icons-material'
import { Box, Chip, Typography } from '@mui/material'

import { SmartPayProcessingResult } from 'types'

interface ProcessingSummaryProps {
  result: SmartPayProcessingResult
}

export const ProcessingSummary = ({ result }: ProcessingSummaryProps) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant='h6' gutterBottom>
        Processing Results
      </Typography>
      <Typography variant='body2' color='textSecondary' gutterBottom>
        File: {result.fileName} | Processed: {new Date(result.processedAt).toLocaleString()}
      </Typography>

      <Box sx={{ display: 'flex', gap: 1, mt: 2, flexWrap: 'wrap' }}>
        <Chip label={`Total: ${result.totalRecords}`} color='default' size='small' />
        <Chip
          icon={<CheckCircleIcon />}
          label={`Matched: ${result.matchedCount}`}
          color='success'
          size='small'
        />
        <Chip
          icon={<WarningIcon />}
          label={`Mismatched: ${result.mismatchedCount}`}
          color='warning'
          size='small'
        />
        <Chip
          icon={<ArchiveIcon />}
          label={`Matched in Archived: ${result.matchedInArchivedCount}`}
          color='info'
          size='small'
        />
        <Chip
          icon={<ErrorIcon />}
          label={`Not Found: ${result.notFoundCount}`}
          color='error'
          size='small'
        />
        <Chip
          icon={<ErrorIcon />}
          label={`Validation Errors: ${result.validationErrorCount}`}
          color='error'
          size='small'
        />
      </Box>
    </Box>
  )
}
